/* global window */
import { Component } from 'react';

import { convertStringToInteger } from 'common/helpers/numberHelper';

class Pagination extends Component {
  handlePage = (e) => {
    const { search } = this.props;
    e.preventDefault();
    const page = e.currentTarget.getAttribute('data-page');

    try {
      window.scrollTo(0, 0);
    } catch {
      // Not all browsers have scrollTo
    }
    search(page);
  };

  render() {
    const { props } = this;
    const { page, totalRecords } = props;

    if (!page || !totalRecords) {
      return null;
    }
    const currentPage = convertStringToInteger(page);
    const arraySize = 50;
    if (totalRecords <= arraySize) {
      return null;
    }
    const lastPage = Math.ceil(totalRecords / arraySize);
    return (
      <div className="c7-pagination">
        <div className="c7-pagination__pages">
          {renderMiddlePages(currentPage, lastPage, this.handlePage)}
        </div>
        {renderRecordCount(currentPage, arraySize, totalRecords)}
      </div>
    );
  }
}

export default Pagination;

const renderMiddlePages = (page, lastPage, handlePage) => {
  const numberArray = [];
  if (page > 1) {
    numberArray.push('prevPage');
  }
  numberArray.push(1);
  if (page > 4) {
    numberArray.push('...');
  }
  let startNumber = page - 2;
  if (startNumber < 2) {
    startNumber = 2;
  }
  let endNumber = page + 2;
  if (endNumber > lastPage - 1) {
    endNumber = lastPage - 1;
  }
  for (let i = startNumber; i <= endNumber; i += 1) {
    numberArray.push(i);
  }
  if (endNumber < lastPage - 1) {
    numberArray.push('...');
  }
  numberArray.push(lastPage);
  if (page < lastPage) {
    numberArray.push('nextPage');
  }
  return numberArray.map((number, index) => {
    const key = `${index}-${Math.random()}`;
    if (number === '...') {
      return <span key={key}>...</span>;
    }
    if (number === page) {
      return (
        <span key={key} className="current">
          <strong>{number}</strong>
        </span>
      );
    }
    if (number === 'prevPage') {
      return (
        <a onClick={handlePage} data-page={page - 1} key={key}>
          &laquo;
        </a>
      );
    }
    if (number === 'nextPage') {
      return (
        <a onClick={handlePage} data-page={page + 1} key={key}>
          &raquo;
        </a>
      );
    }
    return (
      <a onClick={handlePage} data-page={number} key={key}>
        {number}
      </a>
    );
  });
};

const renderRecordCount = (page, arraySize, totalRecords) => {
  let startRecord = page * arraySize - (arraySize - 1);
  if (startRecord < 1) {
    startRecord = 1;
  }
  let endRecord = page * arraySize;
  if (endRecord > totalRecords) {
    endRecord = totalRecords;
  }
  return (
    <div className="c7-pagination__pages__records">
      <span className="c7-pagination__pages__records__range">
        {startRecord} - {endRecord}
      </span>
      Total: {totalRecords}
    </div>
  );
};
